module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"popup":{"title":"Manage Services"},"form":{"sl":"Sponsor Licence","cosSW":"CoS + Skilled Worker Visa"}}}')
  delete Component.options._Ctor
}
